import React from 'react';
import Karuselli from './Karuselli';

function KivityotSv() {
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <h1>Stenarbeten</h1>
        <p></p>
          <h4>- Stenläggningar</h4>
          <h4>- Stenmurar</h4>
          <h4>- Gabioner</h4>
          <h4>- Stenläggning av parkeringsplatser</h4>
          <h4>- Betongsten</h4>
          <h4>- Natursten</h4>
      </div>
      <div className="carousel-container">
        <Karuselli folder="kivityot" imageCount={16}/>
      </div>
    </div>
  );
}

export default KivityotSv;
